import React, { useEffect, useRef, useState } from 'react';
// import { FocusTrap } from '@mui/base/FocusTrap';
// import { FocusTrap } from '@mui/material/Unstable_TrapFocus';

import { FocusTrap } from '../../utils/FocusTrap/index';
// const { FocusTrap } = require('../../dist/focus-trap-react');
// import { FocusTrap } from 'focus-trap-react';

import { useOutsideAlerter } from "../utils";
import { useFormatUSD } from '../../utils/formatting';
import { useQuoteState } from "./quoteState";
import { MinusIcon, PdfIcon, PlusIcon } from "../../utils/icons"




const MiniQuoteItem = ({item}) => {
  
    const { updateItem } = useQuoteState();

    const optionsMiniCart = item.options?.length > 0
      ? item.options
          .filter((option) => option.key?.substring(0, 3) !== '_io')
          .map((option) => (
            <li key={option.key}>
              {option.key?.substring(0, 1) === '_'
                ? option.label.replace('_', '')
                : option.label.replace('_', ' ')}
              : {option.value}
            </li>
          ))
      : [];
    
    return (
      
        <div className="mini-cart__line-item">
    
            <div className="mini-cart__image-wrapper">
              <div className={ item.aspectRatio < 1 ? "aspect-ratio aspect-ratio--square" : "aspect-ratio" } style={{ paddingBottom: 100 / item.aspectRatio + '%' }}>
                <a href={item.url} target="_blank">
                  <img src={item.featuredImage} width="95px" alt={item.title} />  
                </a>
              </div>
            </div>
    
            <div className="mini-cart__item-wrapper">
              <div className="mini-cart__product-info">
                <a href={ item.url } className="mini-cart__product-title text--strong link">{ item.title } { item.variantTitle ? ' - ' + item.variantTitle : '' }</a>
    
                { optionsMiniCart.length > 0 ? 
                  <ul className="mini-cart__property-list" >
                    {optionsMiniCart}
                    {
                      item.manual ? (
                        <li className="manual">
                          <PdfIcon />&nbsp;
                          <a target="_blank" className="link manual_url" href={item.manual}>Product Manual</a>
                        </li>
                      ) : ("")}
                  </ul>
                : "" }
    
                {/* <div className="mini-cart__price-list">
                  <p className="item-price">{useFormatUSD(item.price * item.quantity / 100)}</p>
                </div> */}

                {!item.tags?.includes('Hide Price') && (
                  <div className="mini-cart__price-list">
                    { item.compareAtPrice ? 
                      <>
                        <span className="price price--highlight">{useFormatUSD(item.price * item.quantity / 100)}</span>
                        <span className="price price--msrp" aria-label="MSRP">MSRP: </span>
                        <span className="price price--compare" aria-label="Compare At Price">{useFormatUSD(item.compareAtPrice * item.quantity / 100)}</span>
                      </>
                    : <span className="price">{useFormatUSD(item.price * item.quantity / 100)}</span> 
                    }
                  </div>
                )}

              </div>
    
              <div className="mini-cart__quantity">
                <div className="quantity-selector quantity-selector__quote">
                  <button className="quantity-selector__button qty-minus" onClick={() => updateItem(item, {quantity: item.quantity - 1})} aria-label="Decrease quantity by 1" title="Decrease quantity by 1"><MinusIcon /></button>
                  <input className="quantity-selector__value" type="text" value={item.quantity} min="0" pattern="[0-9]*" onChange={(e) => {(e.target.value != "") ? updateItem(item, {quantity: parseInt(e.target.value)}) : null} } aria-label="Quantity" />
                  <button className="quantity-selector__button qty-plus" onClick={() => updateItem(item, {quantity: item.quantity + 1})} aria-label="Increase quantity by 1" title="Increase quantity by 1"><PlusIcon /></button>
                </div>
                <button className="mini-cart__quantity-remove qty-delete" onClick={() => updateItem(item, {quantity: 0})}>Remove</button>
              </div>
            </div>
    
        </div>
      
    );
}
  
  
  
export const MiniQuote = ({ isOpen, onClose, toggleMiniQuote, quoteLinkRef}) => {
    const { items, totalPrice, setShowMiniQuote } = useQuoteState();
    const dropDownRef = useRef(null);
    useOutsideAlerter(dropDownRef, isOpen, toggleMiniQuote, quoteLinkRef, true);

    // console.log('dropDownRef', dropDownRef, quoteLinkRef);

    const [initialMaxHeight, setInitialMaxHeight] = useState('');

    useEffect(() => {
      if (!isOpen) return;

      const compute = () => {
        const isMobile = window.matchMedia('screen and (max-width: 640px)').matches;
        if (!isMobile) return '';

        const headerBottom = document
          .querySelector('.header')
          ?.getBoundingClientRect?.().bottom;

        // Keep previous behavior, but avoid hard crashes if header is missing.
        const bottomOffset = (typeof headerBottom === 'number' ? headerBottom : 0) + 162;
        return window.innerHeight - bottomOffset;
      };

      const update = () => setInitialMaxHeight(compute());
      update();

      window.addEventListener('resize', update);
      return () => window.removeEventListener('resize', update);
    }, [isOpen]);

    // console.log('maxHeight', maxHeight);
    // const toggleMiniQuote = (e) => {
    //     e.preventDefault();
    //     let miniQuote = document.getElementById('quote-cart');
    //     if (isOpen) { setShowMiniQuote(false); } else { setShowMiniQuote(true);}
    // }

    if (!items) return null;
    // if (!items || window.location.pathname.endsWith('/pages/request-a-quote')) return null;

    return (
      <FocusTrap open>
        <div id="quote-cart" className="mini-quote" aria-hidden={!isOpen} ref={dropDownRef} tabIndex={ isOpen ? -1 : '' }>
            <svg focusable="false" className="icon icon--nav-triangle-borderless" viewBox="0 0 20 9" role="presentation">
                <path d="M.47108938 9c.2694725-.26871321.57077721-.56867841.90388257-.89986354C3.12384116 6.36134886 5.74788116 3.76338565 9.2467995.30653888c.4145057-.4095171 1.0844277-.40860098 1.4977971.00205122L19.4935156 9H.47108938z" fill="#ffffff"></path>
            </svg>
            <div className="mini-cart__inner" >
                <div className="mini-cart__content" style={{ maxHeight: isOpen ? initialMaxHeight : '' }}>
                  <div className="mini-cart__line-item-list">
                  {items.map((item) => (
                      <MiniQuoteItem key={item.id} item={item}/>
                  ))}
                  </div>
                </div>

                <div className="mini-cart__recap">
                    <div className="mini-cart__recap-price-line">
                      <span className="item-price-label">Subtotal:</span>
                      <span className="item-price quote-subtotal-price">{useFormatUSD(totalPrice / 100)}</span>
                    </div>
                    
                    <div className="mini-cart__recap-price-line">
                      <span className="mini-cart__amount-saved">Request a Quote Today!</span>
                      {items.length > 0 ? <button onClick={() => setShowMiniQuote(false)} className="convert_to_cart_button link">Add Quote Items to Cart</button> : null }
                    </div>
                    
                    <div className="mini-cart__button-container">
                        <div className="button-group button-group--loose button-group--fit">
                            <a id="quote_drop_button" className="button button--primary" href="/pages/request-a-quote">Complete Your Quote Request!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </FocusTrap>
    );
}
